import { APP_PMP_URL } from '@/config';
declare const gdprRegister: any;
const PMP_ID = 'PMP_ID';

const getConfig = () => {
  return {
    formSelector: '#UserAccount',
    submitSelector: '#UserAccountButton',
    acceptanceSelector: '#legalTerms',
    emailSelector: '#email',
  };
};

const checkFile = () => {
  const existingScript = document.getElementById(PMP_ID);
  return existingScript;
};

export const loadPmp = () => {
  if (!checkFile() && APP_PMP_URL) {
    const script = document.createElement('script');
    script.src = APP_PMP_URL;
    script.id = PMP_ID;
    document.body.appendChild(script);
    script.onload = () => {
      console.log('PMP Script loaded.');
    };
  }
};

export const sendToPmpData = (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();
  if (checkFile() && APP_PMP_URL) {
    const config = getConfig();
    gdprRegister(event, config.submitSelector, config.acceptanceSelector, config.emailSelector);
  }
};
